import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../@types/GerenciadorPrecos';
import { RootState } from '../../@types/RootState';
import { Sort as DefaultSort, SortPriceType } from '../../@types/sort';

type DataKey = GerenciadorPrecos.DataKey;

type Sort = DefaultSort<DataKey> & {
  priceType: SortPriceType;
};

const initialState: Sort = {
  type: 'competitorsPrice',
  orderBy: 'asc',
  priceType: 'REGULAR',
};

const slice = createSlice({
  name: 'ipa/gerenciador/sort',
  initialState,
  reducers: {
    SET_GERENCIADOR_SORT(state, { payload }: PayloadAction<DefaultSort<DataKey> & { priceType?: SortPriceType }>) {
      state.type = payload.type;
      state.orderBy = payload.orderBy;
      state.priceType = payload.priceType ?? state.priceType;
    },
    UPDATE_GERENCIADOR_SORT_COLUMN: (state, { payload }: PayloadAction<DataKey>) => {
      state.type = payload;
    },
    UPDATE_GERENCIADOR_SORT_ORDER_BY: (state, { payload }: PayloadAction<Sort['orderBy']>) => {
      state.orderBy = payload;
    },
    SET_GERENCIADOR_SORT_PRICE_TYPE: (state, { payload }: PayloadAction<SortPriceType>) => {
      state.priceType = payload;
    },
  },
});

const selectorSort = (state: RootState) => {
  return state.gerenciadorPrecosReducer.sort;
};

const { SET_GERENCIADOR_SORT, UPDATE_GERENCIADOR_SORT_ORDER_BY, UPDATE_GERENCIADOR_SORT_COLUMN, SET_GERENCIADOR_SORT_PRICE_TYPE } = slice.actions;

export { SET_GERENCIADOR_SORT, SET_GERENCIADOR_SORT_PRICE_TYPE, UPDATE_GERENCIADOR_SORT_COLUMN, UPDATE_GERENCIADOR_SORT_ORDER_BY, initialState, selectorSort };

export default slice.reducer;
